import { StateParams, StateService } from "@uirouter/angularjs";
import { IOnInit } from "angular";

import { IQuery } from "../../../../records/server/query";
import { IFieldArray } from "AngularFormly";
import { FormViewController } from "../../../../../app/records/forms/formView/controller";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../../app/records/server/serverUtility";

import {
  FormViewService,
  vsName as FormViewServiceName,
} from "../../../../../app/records/forms/formView/service";
import fieldHelpers from "../../../../../app/ui-formly/fieldHelpers";

export class ProcessTemplateEditController implements IOnInit {
  static $inject = [
    FormViewServiceName,
    "$state",
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
    "$scope",
  ];

  readonly defaultQuery: IQuery = {};

  /* bindings */
  model: any;
  placeholderOptions: any[] = [];
  /* end bindings */

  formFields!: IFieldArray;

  editor: any;
  selectedPlaceholder: string = "";
  tinyMceOptions: any;

  constructor(
    private readonly formViewService: FormViewService,
    private readonly $state: StateService,
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility,
    private readonly $scope: ng.IScope
  ) {}

  private initializeTinyMCE(): void {
    this.tinyMceOptions = {
      selector: "#tinyMCEContainer",
      content_css: ["writer", "/content.css"],
      inline: false,
      plugins: "importcss",
      toolbar:
        "insertplaceholder | undo redo | formatselect | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat",
      setup: (editor: any) => {
        this.editor = editor;

        editor.on("keyup", () => {
          this.$scope.$apply(() => {
            //this.model.MailBody = editor.getContent();
          });
        });
        editor.ui.registry.addButton("insertplaceholder", {
          icon: "placeholder",
          tooltip: "Insert Placeholder",
          onAction: () => {
            this.openPlaceholderDialog();
          },
        });
      },
      theme: "silver",
      menubar: "file edit view insert format table",
    };
  }
  openPlaceholderDialog(): void {
    const placeholderDropdown = `
      <select id="placeholderDropdown" [(ngModel)]="selectedPlaceholder">
        <option value="">Select a placeholder</option>
        ${this.placeholderOptions
          .map(
            (option: any) => `
          <option value="${option.Path}">${option.DisplayName}</option>
        `
          )
          .join("")}
      </select>
    `;
    const popup = this.editor.windowManager.open({
      title: "Insert Placeholder",
      body: {
        type: "panel",
        items: [
          {
            type: "htmlpanel",
            html: placeholderDropdown,
          },
        ],
      },
      buttons: [
        {
          type: "cancel",
          text: "Cancel",
        },
        {
          type: "submit",
          text: "Insert",
          primary: true,
          name: "submit",
        },
      ],
      onSubmit: () => {
        this.insertPlaceholder();
        popup.close();
      },
    });
  }

  insertPlaceholder(): void {
    const selectedPlaceholder = (
      document.getElementById("placeholderDropdown") as HTMLSelectElement
    ).value;
    if (selectedPlaceholder && this.editor) {
      this.editor.insertContent("{{" + selectedPlaceholder + "}}");
    }
  }

  private initializeFormFields() {
    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleStringField({
            key: "Name",
            name: "Name",
            label: "Name",
            required: true,
          }),
        ],
        2
      ),
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleStringField({
            key: "MailSubject",
            name: "MailSubject",
            label: "Mail Subject",
            required: true,
          }),
        ],
        2
      ),
      {
        key: "MailBody",
        name: "MailBody",
        type: "tinymce",
        templateOptions: {
          tinyMceOptions: this.tinyMceOptions,
          required: true,
        },
      },
    ];
  }

  $onInit(): void {
    this.initializeTinyMCE();
    this.initializeFormFields();
  }

  async submit(formViewController: FormViewController): Promise<void> {
    if (this.model.Id == null) {
      await this.formViewService.submitForm({
        url: `/api/process/template`,
        formObject: this.model,
        formViewController,
        method: "POST",
      });
    } else {
      await this.formViewService.submitForm({
        url: `/api/process/template/${this.model.Id}`,
        formObject: this.model,
        formViewController,
        method: "PUT",
      });
    }
    await this.$state.go("^.grid", undefined, {
      reload: true,
    });
  }

  async cancel() {
    await this.$state.go("^.grid", undefined, {
      reload: true,
    });
  }
}
